import { CdkPortalOutlet } from '@angular/cdk/portal';

import { Component, ComponentRef, computed, inject, viewChild } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { CwSidebar } from '@bbraun/cortex-angular';
import { TranslocoDirective } from '@jsverse/transloco';

import { BaseSidebar } from '@/app/shared/ui-common/sidebar/base-sidebar/base-sidebar.abstract';
import { SidebarService } from '@/app/shared/ui-common/sidebar/sidebar.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  imports: [CwSidebar, TranslocoDirective, CdkPortalOutlet],
})
export class SidebarComponent {
  private readonly sidebarService = inject(SidebarService);

  state = toSignal(this.sidebarService.sidebarState$);

  component = viewChild(CdkPortalOutlet);
  componentInstance = computed(
    () => (this.component()?.attachedRef as ComponentRef<BaseSidebar>).instance,
  );
}
